import { toast } from "react-toastify";

const toastMiddleware = () => (next) => (action) => {
  if (action.type === "SEND_TOAST") {
    const { state, payload, options } = action;

    if (state === "success") toast.success(payload, options);
    else if (state === "error") toast.error(payload, options);
    else if (state === "warn") toast.warn(payload, options);
    else if (state === "info") toast.info(payload, options);
    else toast(payload);

    return;
  }

  return next(action);
};

export default toastMiddleware;
